import gql from 'graphql-tag'

export const RichContentHtml = gql`
  fragment RichContentHtml on RichContent {
    content(filter: HTML) {
      content
    }
  }
`
